module.exports = __webpack_public_path__ + "17c757958ef7d24facfe3df9d9c41fa0.png";


//////////////////
// WEBPACK FOOTER
// ./js/img/hvp_logo.png
// module id = 1344
// module chunks = 0